export const RESTING_TRANSITION_STATE = {
    enter: false,
    enterActive: false,
    exit: false,
    exitActive: false,
    interrupted: false,
};
export const getInitialTransitionState = (preventMountTransition) => ({
    ...RESTING_TRANSITION_STATE,
    enter: !preventMountTransition,
});
export const transitionReducer = (state, action) => {
    switch (action.type) {
        case "enter-before":
            return {
                enter: true,
                enterActive: false,
                exit: false,
                exitActive: false,
                interrupted: state.interrupted || state.exit,
            };
        case "enter-active":
            return {
                enter: true,
                enterActive: true,
                exit: false,
                exitActive: false,
                interrupted: false,
            };
        case "exit-before":
            return {
                enter: false,
                enterActive: false,
                exit: true,
                exitActive: false,
                interrupted: state.interrupted || state.enter,
            };
        case "exit-active":
            return {
                enter: false,
                enterActive: false,
                exit: true,
                exitActive: true,
                interrupted: false,
            };
        case "done":
        default:
            return RESTING_TRANSITION_STATE;
    }
};
//# sourceMappingURL=transitionReducer.js.map